import React from "react";

// Statically import all testimonial images to avoid dynamic require overhead in render loop
import t1 from "./images/t1.jpg";
import t2 from "./images/t2.jpg";
import t3 from "./images/t3.jpg";
import t4 from "./images/t4.jpg";
import t5 from "./images/t5.jpg";
import t6 from "./images/t6.jpg";

// Map image IDs to their corresponding static imports
const imageMap: Record<number, string> = {
  1: t1,
  2: t2,
  3: t3,
  4: t4,
  5: t5,
  6: t6,
};

interface TestimonialCardProps {
  text: string;
  name: string;
  title: string;
  imageId?: number; // Optional image ID to match with image files
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  text,
  name,
  title,
  imageId = 1, // Default to first image if none specified
}) => {
  // Get the static image path from the map, fallback to t1 if not found
  const imagePath = imageMap[imageId] || imageMap[1];

  return (
    <div className="testimonial-card">
      <div className="before-after">
        <img
          src={imagePath}
          alt={`${name}'s transformation`}
          className="transformation-image"
        />
      </div>
      <div className="testimonial-content">
        <p className="testimonial-text">"{text}"</p>
        <div className="client-info">
          <div className="client-details">
            <h4>{name}</h4>
            <p>{title}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
